import { Component, ViewChild, TemplateRef, Renderer2, OnChanges, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { TaskActionsHistoryComponent } from '../task-actions-history/task-actions-history.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { dynamiclabelService } from 'src/app/dynamiclabel.service';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { MatTabGroup } from '@angular/material/tabs';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';
import { QualityDependentsComponent } from '../quality-dependents/quality-dependents.component';

@Component({
  selector: 'app-cc',
  templateUrl: './cc.component.html',
  styleUrls: ['./cc.component.scss']
})

export class CcComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  infoIconSrc: string = '../../assets/img/info-yellow.png';
  @ViewChild('flexible') flexibleComponent!: FlexibleFieldsComponent;

  isProcessing: boolean;
  dateCustomClasses: DatepickerDateCustomClasses[];
  ccData: any = {};
  isComplainantSectionFrozen: boolean;
  isDateSectionFrozen: boolean;
  isIdentificationSectionFrozen: boolean;
  isInvestigationSectionFrozen: boolean;
  isFinalEvalSectionFrozen: boolean;
  isReimbursementSectionFrozen: boolean;
  isResponseSectionFrozen: boolean;

  freezeComplaintGroupDropDown: boolean;
  showInvestigationIfOthers: boolean;
  showMarketAction: boolean;
  showLocationIfOthers: boolean;
  elite_toggle: boolean; /* Exclusive privilege to edit action, reimbursement, response and risk toggle buttons */
  elite_Investigation: boolean = false; /* Exclusive privilege to edit investigation toggle button and dropdown */
  showParallelWorkflowAddButton: boolean = false;
  skipValidationsWhileSwitchingUser: boolean = false;
  isStageUsersSkipped: boolean = false;
  isAdditionalTabUser: boolean = false;
  attachAllDocuments: boolean = false;
  constructor(
    public router: Router,
    public dialog: MatDialog,
    public qmsService: qmsService,
    public message: messageService,
    public dynamicLabelService: dynamiclabelService,
    public taskActionsHistoryComponent: TaskActionsHistoryComponent,
    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
    public dependencyNavigationService: DependencyNavigationService,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.freezeComplaintGroupDropDown = true;
    this.isAdditionalTabUser = this.qmsService?.userRole[0]?.qmsRoles?.includes("Additional Tab User");
    this.appService.getTaskStages(qmsService.activityId, 0).subscribe((stageUser: any) => {
      this.isStageUsersSkipped = !stageUser.length;
    })
  }

  @ViewChild(QualityDependentsComponent) dependentsComp!: QualityDependentsComponent;
  public openDependentsPopup(): void {
    this.dependentsComp.openPopup();
  }
  dropDownForCcGroup: any = [];
  dropDownForReporterTitle: any = [];
  dropDownForReporterType: any = [];
  dropDownForReporterCountry: any = [];
  dropDownForNatureOfComplaint: any = [];
  dropDownForLocations: any = [];
  dropDownForDepartment: any = [];
  dropDownForReportedComplaintType: any = [];
  dropDownForSourceOfComplaint: any = [];
  dropDownForEvaluator: any = [];
  dropDownForCompanyComplaintType: any = [];
  dropDownForInvestigator: any = [];
  dropDownForInvestigationTechnique: any = [];
  dropDownForMarketAction: any = [];
  dropDownForFinalCompanyComplaintType: any = [];
  dropDownForFinalComplaintCategory: any = [];
  dropDownForMethodOfResponse: any = [];
  dropDownForReimbursementType: any = [];
  dropDownForResponseStatus: any = [];
  dropDownForReimbursementStatus: any = [];

  ccGroupDropDown: any = [];
  reporterTitleDropDown: any = [];
  reporterTypeDropDown: any = [];
  reporterCountryDropDown: any = [];
  natureOfComplaintDropDown: any = [];
  locationsDropDown: any = [];
  departmentDropDown: any = [];
  reportedComplaintTypeDropDown: any = [];
  sourceOfComplaintDropDown: any = [];
  evaluatorDropDown: any = [];
  companyComplaintTypeDropDown: any = [];
  investigatorDropDown: any = [];
  investigationTechniqueDropDown: any = [];
  marketActionDropDown: any = [];
  finalCompanyComplaintTypeDropDown: any = [];
  finalComplaintCategoryDropDown: any = [];
  methodOfResponseDropDown: any = [];
  reimbursementTypeDropDown: any = [];
  responseStatusDropDown: any = [];
  reimbursementStatusDropDown: any = [];

  titleSearchText: string = '';
  reporterTypeSearchText: string = '';
  reporterCountrySearchText: string = '';
  evaluatorSearchText: string = '';
  natureOfComplaintSearchText: string = '';
  locationSearchText: string = '';
  departmentSearchText: string = '';
  initialCategorySearchText: string = '';
  sourceOfComplaintSearchText: string = '';
  qaSearchText: string = '';
  companyComplaintTypeSearchText: string = '';
  investigatorSearchText: string = '';
  investigatorTechniqueSearchText: string = '';
  marketActionSearchText: string = '';
  finalCategorySearchText: string = '';
  finalComplaintTypeSearchText: string = '';
  reimbursementStatusSearchText: string = '';
  responseStatusSearchText: string = '';
  methodOfResponseSearchText: string = '';

  oddTitle: any = null;
  oddType: any = null;
  oddCountry: any = null;
  oddEvaluator: any = null;
  oddNatureOfComplaint: any = null;
  oddLocation: any = null;
  oddDepartment: any = null;
  oddSourceOfComplaint: any = null;
  oddQA: any = null;
  oddInitialComplaintType: any = null;
  oddInvestigator: any = null;
  oddInvestigationTechnique: any = null;
  oddMarketAction: any = null;
  oddFinalComplaintType: any = null;
  oddReimbursementStatus: any = null;
  oddReimbursementType: any = null;
  oddResponseStatus: any = null;
  oddMethodOfResponse: any = null;

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  openGroupMethod() {
    this.topNavigationComponent.opengroupPopup();
  }

  clearDropdowns() {
    Object.keys(this.qmsService.ccDropDowns).forEach(key => {
      if (key === 'selectedDepartment' || key === 'selectedReportedComplaintType' || key === 'selectedFinalComplaintCategory' || key === 'selectedMethodOfResponse') {
        this.qmsService.ccDropDowns[key] = [];
      } else {
        this.qmsService.ccDropDowns[key] = null;
      }
    })
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  stageName: any;
  actionStatusOptions: any;
  instructions = "";
  buttonLabels: string[] = [];
  saveButtonForTraining: boolean = false;
  objForDocuments: any;
  selectedTab: any;
  selectedTabIndex: any;
  selectedTabName: any;
  tabIndex: number = 0;

  onTabChanged($event: any) {
    this.selectedTab = this.selectedTabName = $event.tab.textLabel;
    this.tabIndex = this.qmsService.ccTabIndex = $event.index;
  }

  statusAppearance(status: string) {
    if (!status) {
      return null;
    }

    let color = '#0f3659';
    let background = '';
    let border = '0.75px solid #0f3659';

    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      color = '#FF3A29';
      background = '#FF3A291A';
      border = '0.75px solid #FF3A29';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      color = '#FF8900';
      background = '#FF89001A';
      border = '0.75px solid #FF8900';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      color = '#00E58F';
      background = '#00E58F1A';
      border = '0.75px solid #00E58F';
    } else if (status.includes('QA Accepted') || status.includes('Owner Acknowledged') || status.includes('Pending Closure Approval') ||
      status.includes('In Progress') || status.includes('Pending Closure Review') || status.includes('Pending QA Acceptance') ||
      status.includes('Pending Obsolete Approval')) {
      background = '#005C8A1A';
      border = '0.75px solid #005C8A1A';
    }

    return {
      color,
      background,
      border,
      'font-family': 'Poppins',
      'border-radius': '6px',
      'padding': '3px 9px',
      'font-size': '16px !important',
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '15px'
    };
  }

  private readonly model: {
    documents: any[];
    action: any[];
    preAction: any[],
    stagesUser: any[];
    extension: any[];
    effectiveness: any[];
    dependency: any[];
    parallelWorkFlow: any[];
    products: any[];
  } = {
      documents: [],
      action: [],
      preAction: [],
      stagesUser: [],
      extension: [],
      effectiveness: [],
      dependency: [],
      parallelWorkFlow: [],
      products: [],
    };

  public on_documents_emit($event: any): void {
    this.model.action = $event.action;
  }

  public on_action_emit($event: any): void {
    this.model.documents = $event.documents;
  }

  public on_preAction_emit($event: any): void {
    this.model.preAction = $event.preAction;
  }

  public on_stageUser_emit($event: any): void {
    this.model.stagesUser = $event.stages;
  }

  public on_extension_emit($event: { $extension: any[], $destroying?: boolean }): void {
    if ($event?.$destroying) {
      this.appService.getCcDetailsByCcNo(this.qmsService.activityId).subscribe((cc: any) => {
        this.ccData.expcetedClosureOn = this.qmsService.activity.expcetedClosureOn = new Date(cc.expcetedClosureOn);
      })
    }

    this.model.extension = $event.$extension;
  }

  public on_effectiveness_emit($event: any): void {
    this.model.effectiveness = $event.effectiveness;
  }

  public on_dependency_emit($event: any): void {
    this.model.dependency = $event.dependency;
  }

  public on_parallelWorkFlow_emit($event: any): void {
    this.model.parallelWorkFlow = $event.parallelWorkFlow;
  }

  public on_products_emit($event: any): void {
    this.model.products = $event.product;
  }

  getColor(status: any) {
    if (status) {
      if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
        return 'red';
      } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
        return 'orange';
      } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
        return 'green';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  dropdownForQA: any;

  label: any = [];
  dynamicLabel: any = null;
  dynamicLabelCall() {
    this.isProcessing = true;

    const data = {
      tableName: 'QMS_CC_GRID_VW',
      moduleName: 'CC',
      gridName: 'CC',
      groupId: this.qmsService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          this.qmsService.activityDynamicLabel = acc;
          return acc;
        }, {});
        this.isProcessing = false;
        console.log(this.dynamicLabel);
        console.log(this.dynamicLabel['IS_REPONSE_REQUESTED_BY_CUSTOMER']?.fieldName);
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.initiate();

    this.dependencyNavigationService.refresh.subscribe(() => {
      if (this.qmsService.moduleName == 'CC') {
        this.initiate();
      }
    });
  }


  private initiate(): void {
    this.selectedTabIndex = 0;
    this.ngOnChangesReportFooter();
    this.isProcessing = true;

    this.clearDropdowns();
    this.dynamicLabelCall();

    this.objForDocuments = { id: this.qmsService.activityId, pagename: "Activity" };

    const groupId = this.qmsService.selectedActivityGroupId;
    const moduleName = this.qmsService.moduleName;
    const getGroupsModuleCurrentUserVw$ = this.appService.getGroupsModuleCurrentUserVw("CC");
    const getCodeListsByReporterTitle$ = this.appService.getCodeListsByGroup("COMPLAINT_REPORTER_TITLE");
    const getCodeListsByReporterType$ = this.appService.getCodeListsByGroup("COMPLAINT_REPORTER_TYPE");
    const getCodeListsByCountry$ = this.appService.getNonOrgCodeListsByGroupName("COUNTRY");
    const getCodeListsByNatureOfComplaint$ = this.appService.getCodeListsByGroup("NATURE_OF_COMPLAINT");
    const getAllLocationsByLocationMaster$ = this.appService.getAllLocations();
    const getCodeListByLocationDepartment$ = this.appService.getCodeListsByGroup("LOCATION_DEPARTMENT");
    const getCodeListsByComplaintType$ = this.appService.getCodeListsByGroup("TYPE_OF_POTENTIAL_COMPLAINT");
    const getCodeListsBySourceOfComplaint$ = this.appService.getCodeListsByGroup("SOURCE_OF_COMPLAINT");
    const getEvaluators$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, "Evaluator");
    const getCodeListsByCompanyComplaintType$ = this.appService.getCodeListsByGroup("CC_TYPE");
    const getInvestigators$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, "Investigator");

    const getCodeListsByInvestigationTechnique$ = this.appService.getCodeListsByGroup("INVESTIGATION_TECHNIQUE");
    const getCodeListsByMarketAction$ = this.appService.getCodeListsByGroup("MARKET_ACTION");
    const getCodeListsByMethodOfResponse$ = this.appService.getCodeListsByGroup("METHOD_OF_RESPONSE");
    const getCodeListsByResponseStatus$ = this.appService.getCodeListsByGroup("RESPONSE_STATUS");
    const getCodeListsByReimbursementType$ = this.appService.getCodeListsByGroup("REIMBURSEMENT_TYPE");
    const getCodeListsByReimbursementStatus$ = this.appService.getCodeListsByGroup("REIMBURSEMENT_STATUS");
    const getQmsReportTemplateDetailsByModule$ = this.appService.getQmsReportTemplateDetailsByModuleAndGroupId(moduleName, groupId);

    const getQA$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, 'QA');
    const getOrgReportImage$ = this.appService.getOneQmsOrganizationReportImage();
    const getReportLogo$ = this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.qmsService.selectedActivityGroupId);

    forkJoin([
      getGroupsModuleCurrentUserVw$,
      getCodeListsByReporterTitle$,
      getCodeListsByReporterType$,
      getCodeListsByCountry$,
      getCodeListsByNatureOfComplaint$,
      getAllLocationsByLocationMaster$,
      getCodeListByLocationDepartment$,
      getCodeListsByComplaintType$,
      getCodeListsBySourceOfComplaint$,
      getEvaluators$,
      getCodeListsByCompanyComplaintType$,
      getInvestigators$,
      getCodeListsByInvestigationTechnique$,
      getCodeListsByMarketAction$,
      getCodeListsByMethodOfResponse$,
      getCodeListsByResponseStatus$,
      getCodeListsByReimbursementType$,
      getCodeListsByReimbursementStatus$,
      getQmsReportTemplateDetailsByModule$,
      getQA$,
      getOrgReportImage$,
      getReportLogo$
    ]).pipe(
      switchMap((
        [groupsData, reporterTitleData, reporterTypeData, reporterCountryData, natureOfComplaintData, locationsData, locationDeptData, complaintTypeData,
          sourceOfComplaintData, evaluatorData, companyComplaintTypeData, investigatorData, investigationTechniqueData, marketActionData, methodOfResponseData,
          responseStatusData, reimbursementTypeData, reimbursementStatusData, getQmsReportTemplateDetailsByModule, qa, reportImage, reportLogo]) => {

        this.dropDownForCcGroup = groupsData;
        this.selectBoxForCcGroup();

        this.dropDownForReporterTitle = reporterTitleData;
        this.selectBoxForReporterTitle();

        this.dropDownForReporterType = reporterTypeData;
        this.selectBoxForReporterType();

        this.dropDownForReporterCountry = reporterCountryData;
        this.selectBoxForReporterCountry();

        this.dropDownForNatureOfComplaint = natureOfComplaintData;
        this.selectBoxForNatureOfComplaint();

        this.dropDownForLocations = locationsData;
        this.selectBoxForLocations();

        this.dropDownForDepartment = locationDeptData;
        this.selectBoxForDepartment();

        this.dropDownForReportedComplaintType = complaintTypeData;
        this.selectBoxForReportedComplaintType();

        this.dropDownForSourceOfComplaint = sourceOfComplaintData;
        this.selectBoxForSourceOfComplaint();

        this.dropDownForEvaluator = evaluatorData;
        this.selectBoxForEvaluator();

        this.dropDownForCompanyComplaintType = companyComplaintTypeData;
        this.selectBoxForCompanyComplaintType();

        this.dropDownForInvestigator = investigatorData;
        this.selectBoxForInvestigator();

        this.dropDownForInvestigationTechnique = investigationTechniqueData;
        this.selectBoxForInvestigationTechnique();

        this.dropDownForMarketAction = marketActionData;
        this.selectBoxForMarketAction();

        this.dropDownForFinalComplaintCategory = complaintTypeData;
        this.selectBoxForFinalComplaintCategory();

        this.dropDownForFinalCompanyComplaintType = companyComplaintTypeData;
        this.selectBoxForFinalCompanyComplaintType();

        this.dropDownForMethodOfResponse = methodOfResponseData;
        this.selectBoxForMethodOfResponse();

        this.dropDownForResponseStatus = responseStatusData;
        this.selectBoxForResponseStatus();

        this.dropDownForReimbursementType = reimbursementTypeData;
        this.selectBoxForReimbursementType();

        this.dropDownForReimbursementStatus = reimbursementStatusData;
        this.selectBoxForReimbursementStatus();

        this.dropDownDataForReportTemplate = getQmsReportTemplateDetailsByModule;
        this.selectBoxForReportTemplate();

        this.dropdownForQA = qa;
        this.selectBoxForQA();

        this.organizationReportImageDetails = reportImage;

        this.dropDownDataForReportLogo = reportLogo;
        this.selectBoxForReportLogo();

        return this.appService.getCcDetailsByCcNo(this.qmsService.activityId);
      })
    ).subscribe((ccDetails: any) => {

      ccDetails.dateOfOccurrence = ccDetails.dateOfOccurrence ? new Date(ccDetails.dateOfOccurrence) : null;
      ccDetails.dateReported = ccDetails.dateReported ? new Date(ccDetails.dateReported) : null;
      ccDetails.dateOfResponse = ccDetails.dateOfResponse ? new Date(ccDetails.dateOfResponse) : null;
      ccDetails.reimbursemntRequestedDate = ccDetails.reimbursemntRequestedDate ? new Date(ccDetails.reimbursemntRequestedDate) : null;
      ccDetails.reimbursemntInitiatedDate = ccDetails.reimbursemntInitiatedDate ? new Date(ccDetails.reimbursemntInitiatedDate) : null;
      ccDetails.reimbursemntReceivedDate = ccDetails.reimbursemntReceivedDate ? new Date(ccDetails.reimbursemntReceivedDate) : null;

      ccDetails.isProductComplaint = ccDetails.isProductComplaint == "Y";
      ccDetails.actionItemsReqd = ccDetails.actionItemsReqd == "Y";
      ccDetails.preActionItemsReqd = ccDetails.preActionItemsReqd == "Y";
      ccDetails.isInvestigationReqd = ccDetails.isInvestigationReqd == "Y";
      ccDetails.isMarketActionReqd = ccDetails.isMarketActionReqd == "Y";
      ccDetails.isReponseRequestedByCustomer = ccDetails.isReponseRequestedByCustomer == "Y";
      ccDetails.isReimbursementReqd = ccDetails.isReimbursementReqd == "Y";
      ccDetails.isSampleReturned = ccDetails.isSampleReturned == "Y";
      ccDetails.isRiskCalculationReqd = ccDetails.isRiskCalculationReqd == "Y";

      ccDetails.expcetedClosureOn = ccDetails.expcetedClosureOn ? new Date(ccDetails.expcetedClosureOn) : null;
      ccDetails.groupReassignedOn = ccDetails.groupReassignedOn ? new Date(ccDetails.groupReassignedOn) : null;
      ccDetails.startedOn = ccDetails.startedOn ? new Date(ccDetails.startedOn) : null;
      ccDetails.completedOn = ccDetails.completedOn ? new Date(ccDetails.completedOn) : null;
      ccDetails.lastActionOn = ccDetails.lastActionOn ? new Date(ccDetails.lastActionOn) : null;

      this.ccData = ccDetails;
      this.qmsService.activity = ccDetails;
      this.parallelWorkflowList = [];
      this.appService.getWorkflowByRefNo(this.qmsService.activityId).subscribe((data: any) => {
        this.parallelWorkflowList = data;
      });
      this.getStageUsers();
      this.getDynamicButtons();
      this.setDropdowns();
      this.ngOnChanges();
      this.isProcessing = false;
    });

  }
  taskStageUsers: any = [];

  getStageUsers() {
    const statusMap: { [key: string]: string } = {
      'Pending Review': 'Review', 'Review Inprogress': 'Review', 'Pending Approval': 'Approve', 'Approval Inprogress': 'Approve'
    };

    const stageName = statusMap[this.ccData.status] || '';

    if (stageName) {
      this.appService.getTaskStageUsers(this.ccData.ccNo, 0, stageName).subscribe((stageUser: any) => {
        this.taskStageUsers = stageUser.filter((user: any) => user.status && user.status != 'Review Completed' && user.status != 'Approval Completed');
        this.statusDependentAesthetic();
      });
    } else {
      this.statusDependentAesthetic();
    }
  }

  qaDropdown: any = [];
  selectBoxForQA() {
    this.qaDropdown = [];
    this.qaDropdown = this.dropdownForQA.map((qa: any) => ({
      valueExp: qa.userId,
      displayExp: qa.userName
    }))
  }

  setDropdowns() {
    this.qmsService.ccDropDowns.selectedCcGroup = this.ccData.groupId;

    const matchingTitle = this.dropDownForReporterTitle?.find((item: any) => item.codelistCode == this.ccData.reporterTitle);
    if (!matchingTitle) {
      this.oddTitle = this.ccData.reporterTitle;
      this.reporterTitleDropDown.push({
        valueExp: this.ccData.reporterTitle,
        displayExp: this.ccData.reporterTitle
      })
    }
    this.qmsService.ccDropDowns.selectedReporterTitle = this.ccData.reporterTitle;

    if (this.ccData.reporterType) {
      const matchingReporterType = this.dropDownForReporterType?.find((item: any) => item.codelistCode == this.ccData.reporterType);
      if (!matchingReporterType) {
        this.oddType = this.ccData.reporterType;
        this.reporterTypeDropDown.push({
          valueExp: this.ccData.reporterType,
          displayExp: this.ccData.reporterType
        })
      }
      this.qmsService.ccDropDowns.selectedReporterType = this.ccData.reporterType;
    }

    if (this.ccData.reporterCountry) {
      const matchingReporterCountry = this.dropDownForReporterCountry?.find((item: any) => item.codelistCode == this.ccData.reporterCountry);
      if (!matchingReporterCountry) {
        this.oddCountry = this.ccData.reporterCountry;
        this.reporterCountryDropDown.push({
          valueExp: this.ccData.reporterCountry,
          displayExp: this.ccData.reporterCountry
        })
      }
      this.qmsService.ccDropDowns.selectedReporterCountry = this.ccData.reporterCountry;
    }

    if (this.ccData.natureOfComplaint) {
      const matchingNatureOfComplaint = this.dropDownForNatureOfComplaint?.find((item: any) => item.codelistCode == this.ccData.natureOfComplaint);
      if (!matchingNatureOfComplaint) {
        this.oddNatureOfComplaint = this.ccData.natureOfComplaint;
        this.natureOfComplaintDropDown.push({
          valueExp: this.ccData.natureOfComplaint,
          displayExp: this.ccData.natureOfComplaint
        })
      }
      this.qmsService.ccDropDowns.selectedNatureOfComplaint = this.ccData.natureOfComplaint;
    }

    if (this.ccData.locationDetails) {
      const matchingLocations = this.dropDownForLocations?.find((item: any) => item.locationId == this.ccData.locationDetails);
      if (!matchingLocations) {
        this.oddLocation = this.ccData.locationDetails;
        this.locationsDropDown.push({
          valueExp: this.ccData.locationDetails,
          displayExp: this.ccData.locationDetails
        })
      }
      this.showLocationIfOthers = matchingLocations?.locationName?.toLowerCase() == 'others';
      this.qmsService.ccDropDowns.selectedLocations = +this.ccData.locationDetails;
      setTimeout(() => { this.showLocationIfOthers ? this.showAllDepartments() : this.selectBoxForDepartment(); }, 1000)
    }

    if (this.ccData.deptCode) {
      this.qmsService.ccDropDowns.selectedDepartment = this.ccData.deptCode.split(',');
    }

    if (this.ccData.reportedComplaintType) {
      this.qmsService.ccDropDowns.selectedReportedComplaintType = this.ccData.reportedComplaintType.split(',');
      this.initialComplaintCategorySelection = this.reportedComplaintTypeDropDown.length == this.qmsService.ccDropDowns.selectedReportedComplaintType.length;
    }

    if (this.ccData.sourceOfComplaint) {
      const matchingSourceOfComplaint = this.dropDownForSourceOfComplaint?.find((item: any) => item.codelistCode == this.ccData.sourceOfComplaint);
      if (!matchingSourceOfComplaint) {
        this.oddSourceOfComplaint = this.ccData.sourceOfComplaint;
        this.sourceOfComplaintDropDown.push({
          valueExp: this.ccData.sourceOfComplaint,
          displayExp: this.ccData.sourceOfComplaint
        })
      }
      this.qmsService.ccDropDowns.selectedSourceOfComplaint = this.ccData.sourceOfComplaint;
    }

    if (this.ccData.evaluator) {
      const matchingEvaluator = this.dropDownForEvaluator?.find((item: any) => item.userId == this.ccData.evaluator);
      if (!matchingEvaluator) {
        this.oddEvaluator = this.ccData.evaluator;
        this.evaluatorDropDown.push({
          valueExp: this.ccData.evaluator,
          displayExp: this.ccData.evaluatorUser
        })
      }
      this.qmsService.ccDropDowns.selectedEvaluator = this.ccData.evaluator;
    }

    if (this.ccData.companyComplaintType) {
      const matchingCompanyComplaintType = this.dropDownForCompanyComplaintType?.find((item: any) => item.codelistCode == this.ccData.companyComplaintType);
      if (!matchingCompanyComplaintType) {
        this.oddInitialComplaintType = this.ccData.companyComplaintType;
        this.companyComplaintTypeDropDown.push({
          valueExp: this.ccData.companyComplaintType,
          displayExp: this.ccData.companyComplaintType
        })
      }
      this.qmsService.ccDropDowns.selectedCompanyComplaintType = this.ccData.companyComplaintType;
    }

    if (this.ccData.investigator) {
      const matchingInvestigator = this.dropDownForInvestigator?.find((item: any) => item.userId == this.ccData.investigator);
      if (!matchingInvestigator) {
        this.oddInvestigator = this.ccData.investigator;
        this.investigatorDropDown.push({
          valueExp: this.ccData.investigator,
          displayExp: this.ccData.investigatorUser
        })
      }
      this.qmsService.ccDropDowns.selectedInvestigator = this.ccData.investigator;
    }

    if (this.ccData.investigationTechnique) {
      const matchingInvestigationTechnique = this.dropDownForInvestigationTechnique?.find((item: any) => item.codelistCode == this.ccData.investigationTechnique);
      if (!matchingInvestigationTechnique) {
        this.oddInvestigationTechnique = this.ccData.investigationTechnique;
        this.investigationTechniqueDropDown.push({
          valueExp: this.ccData.investigationTechnique,
          displayExp: this.ccData.investigationTechnique
        })
      }
      this.qmsService.ccDropDowns.selectedInvestigationTechnique = this.ccData.investigationTechnique;
      this.showInvestigationIfOthers = this.ccData.investigationTechnique.toLowerCase() == 'others';
    }

    if (this.ccData.marketActionReqd) {
      const matchingMarketAction = this.dropDownForMarketAction?.find((item: any) => item.codelistCode == this.ccData.marketActionReqd);
      if (!matchingMarketAction) {
        this.oddMarketAction = this.ccData.marketActionReqd;
        this.marketActionDropDown.push({
          valueExp: this.ccData.marketActionReqd,
          displayExp: this.ccData.marketActionReqd
        })
      }
      this.qmsService.ccDropDowns.selectedMarketAction = this.ccData.marketActionReqd
    }

    if (this.ccData.finalComplaintCategory) {
      this.qmsService.ccDropDowns.selectedFinalComplaintCategory = this.ccData.finalComplaintCategory.split(',');
      this.ccData.finalComplaintCategory.split(',').length == this.dropDownForFinalComplaintCategory.length && this.initialComplaintCategory.options.forEach((item: MatOption) => item.select());
    }

    if (this.ccData.methodOfResponse) {
      const selectedMethodValues = this.ccData.methodOfResponse.split(',');
      this.qmsService.ccDropDowns.selectedMethodOfResponse = selectedMethodValues;

      // Check for missing values that are selected but not in dropdown options
      selectedMethodValues.forEach((selectedValue: string) => {
        const matchingMethodOfResponse = this.dropDownForMethodOfResponse?.find((item: any) => item.codelistCode == selectedValue);
        if (!matchingMethodOfResponse) {
          // Add missing value with special flag for red highlighting
          this.methodOfResponseDropDown.push({
            valueExp: selectedValue,
            displayExp: selectedValue,
            isMissing: true // Flag to identify missing/deleted options
          });
        }
      });

      this.methodOfResponseSelection = this.methodOfResponseDropDown.length == this.qmsService.ccDropDowns.selectedMethodOfResponse.length;
    }

    if (this.ccData.finalCompanyComplaintType) {
      const matchingFinalCompanyComplaintType = this.dropDownForFinalCompanyComplaintType?.find((item: any) => item.codelistCode == this.ccData.finalCompanyComplaintType);
      if (!matchingFinalCompanyComplaintType) {
        this.oddFinalComplaintType = this.ccData.finalCompanyComplaintType;
        this.finalCompanyComplaintTypeDropDown.push({
          valueExp: this.ccData.finalCompanyComplaintType,
          displayExp: this.ccData.finalCompanyComplaintType
        })
      }
      this.qmsService.ccDropDowns.selectedFinalCompanyComplaintType = this.ccData.finalCompanyComplaintType;
    }

    if (this.ccData.reimbursementType) {
      const matchingReimbursementType = this.dropDownForReimbursementType?.find((item: any) => item.codelistCode == this.ccData.reimbursementType);
      if (!matchingReimbursementType) {
        this.oddReimbursementType = this.ccData.reimbursementType;
        this.reimbursementTypeDropDown.push({
          valueExp: this.ccData.reimbursementType,
          displayExp: this.ccData.reimbursementType
        })
      }
      this.qmsService.ccDropDowns.selectedReimbursementType = this.ccData.reimbursementType;
    }

    if (this.ccData.responseStatus) {
      const matchingResponseStatus = this.dropDownForResponseStatus?.find((item: any) => item.codelistCode == this.ccData.responseStatus);
      if (!matchingResponseStatus) {
        this.oddResponseStatus = this.ccData.responseStatus;
        this.responseStatusDropDown.push({
          valueExp: this.ccData.responseStatus,
          displayExp: this.ccData.responseStatus
        })
      }
      this.qmsService.ccDropDowns.selectedResponseStatus = this.ccData.responseStatus;
    }

    if (this.ccData.reimbursementStatus) {
      const matchingReimbursementStatus = this.dropDownForReimbursementStatus?.find((item: any) => item.codelistCode == this.ccData.reimbursementStatus);
      if (!matchingReimbursementStatus) {
        this.oddReimbursementStatus = this.ccData.reimbursementStatus;
        this.reimbursementStatusDropDown.push({
          valueExp: this.ccData.reimbursementStatus,
          displayExp: this.ccData.reimbursementStatus
        })
      }
      this.qmsService.ccDropDowns.selectedReimbursementStatus = this.ccData.reimbursementStatus;
    }

    if (this.ccData.qaUser) {
      const matchingQA = this.dropdownForQA?.find((item: any) => item.userId == this.ccData.qaUser);
      if (!matchingQA) {
        this.oddQA = this.ccData.qaUser;
        this.qaDropdown.push({
          valueExp: this.ccData.qaUser,
          displayExp: this.ccData.qaUserName
        })
      }
      this.qmsService.ccDropDowns.selectedQA = this.ccData.qaUser;
    }
  }

  private processButtonLabels(buttonLabels: string[] | null): string[] {
    const labels = buttonLabels ? [...buttonLabels] : [];
    labels.unshift("Cancel");  // Always add Cancel
    this.qmsService.activityDynamicButtonList = labels;

    // Reset flags
    this.qmsService.showflexifieldshow = false;
    this.qmsService.activitySaveButton = false;

    for (const element of labels) {
      if (/Submit|Review|Approve|Accept/.test(element)) {
        this.qmsService.showflexifieldshow = true;
      }
      if (element === "Save") {
        this.qmsService.activitySaveButton = true;
      }
    }

    return labels;
  }

  private getDynamicButtons() {
    const obj = {
      activityId: this.message.activityId,
      moduleName: this.qmsService.moduleName,
      status: this.ccData.status
    }

    this.appService.getQmsButtons(obj).subscribe((data: any) => {
      this.qmsService.activityDynamicButtonList = [];
      this.buttonLabels = [];
      this.qmsService.activitySaveButton = false;

      if (data.resultType === "S") {
        this.qmsService.showflexifieldshow = false;
        this.stageName = data.stageName;
        this.actionStatusOptions = data.actionStatusOptions;
        this.instructions = data.instructions;
        this.qmsService.activityButtonLabels = data;
        this.buttonLabels = this.processButtonLabels(data.buttonLabels?.split(",") || null);

      } else {
        this.buttonLabels = this.processButtonLabels(null);
        this.showSnackBar(data.result, data.resultType);
      }
    });
  }

  ngOnChanges() {
    this.qmsService.refereshBreadCrumb = true;
  }

  selectBoxForCcGroup() {
    this.ccGroupDropDown = [];
    this.ccGroupDropDown = this.dropDownForCcGroup?.map((item: any) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onCcGroupSelect() {
    this.handleDropDownValidation('group-validation', this.qmsService.ccDropDowns.selectedCcGroup);
  }

  onCcGroupDeSelect() {
    this.handleDropDownValidation('group-validation', this.qmsService.ccDropDowns.selectedCcGroup);
  }


  selectBoxForReporterTitle() {
    this.reporterTitleDropDown = [];
    this.reporterTitleDropDown = this.dropDownForReporterTitle?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onReporterTitleSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('title-validation', item);
    }
  }

  onReporterTitleSelectOld() {
    this.handleDropDownValidation('title-validation', this.qmsService.ccDropDowns.selectedReporterTitle);
  }

  onReporterTitleDeSelect() {
    this.handleDropDownValidation('title-validation', this.qmsService.ccDropDowns.selectedReporterTitle);
  }

  selectBoxForReporterType() {
    this.reporterTypeDropDown = [];
    this.reporterTypeDropDown = this.dropDownForReporterType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onReporterTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('reporter-type-validation', item);
    }
  }

  onReporterTypeSelectOld() {
    this.handleDropDownValidation('reporter-type-validation', this.qmsService.ccDropDowns.selectedReporterType);
  }

  onReporterTypeDeSelect() {
    this.handleDropDownValidation('reporter-type-validation', this.qmsService.ccDropDowns.selectedReporterType);
  }

  selectBoxForReporterCountry() {
    this.reporterCountryDropDown = [];
    this.reporterCountryDropDown = this.dropDownForReporterCountry?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onCountrySelect(event: any, item: any) {
    if (event.isUserInput) {

    }
  }

  selectBoxForNatureOfComplaint() {
    this.natureOfComplaintDropDown = [];
    this.natureOfComplaintDropDown = this.dropDownForNatureOfComplaint?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onNatureOfComplaintSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('nature-of-complaint-validation', item);
    }
  }

  onNatureOfComplaintSelectOld() {
    this.handleDropDownValidation('nature-of-complaint-validation', this.qmsService.ccDropDowns.selectedNatureOfComplaint);
  }

  onNatureOfComplaintDeSelect() {
    this.handleDropDownValidation('nature-of-complaint-validation', this.qmsService.ccDropDowns.selectedNatureOfComplaint);
  }

  selectBoxForLocations() {
    this.locationsDropDown = [];
    this.locationsDropDown = this.dropDownForLocations?.map((item: any) => ({
      valueExp: item.locationId,
      displayExp: item.locationName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onLocationSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        [this.departmentDropDown, this.qmsService.ccDropDowns.selectedDepartment] = [[], []];
        let isNotOthers = item?.displayExp?.toLowerCase() != 'others';
        this.showLocationIfOthers = !isNotOthers;
        if (isNotOthers) {
          setTimeout(() => { this.selectBoxForDepartment() }, 500)
        } else {
          this.showAllDepartments();
          this.qmsService.activity.locationIfOthers = '';
        }
      } else {
        [this.departmentDropDown, this.qmsService.ccDropDowns.selectedDepartment, this.showLocationIfOthers] = [[], [], false];
      }
    }
  }

  onLocationSelectOld(item: any) {
    [this.departmentDropDown, this.qmsService.ccDropDowns.selectedDepartment] = [[], []];
    let isNotOthers = item?.displayExp?.toLowerCase() != 'others';
    this.showLocationIfOthers = !isNotOthers;
    if (isNotOthers) {
      this.selectBoxForDepartment();
    } else {
      this.showAllDepartments();
      this.qmsService.activity.locationIfOthers = '';
    }
  }

  onLocationDeSelect() {
    [this.departmentDropDown, this.qmsService.ccDropDowns.selectedDepartment, this.showLocationIfOthers] = [[], [], false];
  }

  showAllDepartments() {
    this.departmentDropDown = this.dropDownForDepartment?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  selectBoxForDepartment() {
    const getDepartmentsCode = this.dropDownForLocations?.find((item: any) => item.locationId == this.qmsService.ccDropDowns.selectedLocations)
    if (getDepartmentsCode) {
      const departmentsArray: [] = getDepartmentsCode.departments?.split(',')?.map((code: any) => this.dropDownForDepartment?.find((dept: any) => dept.codelistCode == code));
      console.log(departmentsArray);
      if (departmentsArray?.length > 0) {
        this.departmentDropDown = departmentsArray
          .filter((dept: any) => dept !== undefined)?.map((dept: any) => ({
            valueExp: dept.codelistCode,
            displayExp: dept.codelistName
          }))
      }
    }
  }

  onDepartmentSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.departmentSelection = this.departmentDropDown.length == this.qmsService.ccDropDowns.selectedDepartment.length;
      })
    }
  }

  selectBoxForReportedComplaintType() {
    this.reportedComplaintTypeDropDown = [];
    this.reportedComplaintTypeDropDown = this.dropDownForReportedComplaintType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onReportedComplaintTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('initial-complaint-category-validation', this.qmsService.ccDropDowns.selectedReportedComplaintType);
        this.initialComplaintCategorySelection = this.reportedComplaintTypeDropDown.length == this.qmsService.ccDropDowns.selectedReportedComplaintType.length;
      })
    }
  }

  onReportedComplaintTypeSelectOld() {
    this.handleDropDownValidation('initial-complaint-category-validation', this.qmsService.ccDropDowns.selectedReportedComplaintType);
  }

  onReportedComplaintTypeDeSelect() {
    this.handleDropDownValidation('initial-complaint-category-validation', this.qmsService.ccDropDowns.selectedReportedComplaintType);
  }

  onReportedComplaintTypeSelectAll(item: any[]) {
    this.handleDropDownValidation('initial-complaint-category-validation', item);
  }

  onReportedComplaintTypeDeSelectAll(item: any[]) {
    this.handleDropDownValidation('initial-complaint-category-validation', item);
  }

  selectBoxForSourceOfComplaint() {
    this.sourceOfComplaintDropDown = [];
    this.sourceOfComplaintDropDown = this.dropDownForSourceOfComplaint?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onSourceOfComplaintSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('source-of-complaint-validation', item);
  }

  onSourceOfComplaintSelectOld() {
    this.handleDropDownValidation('source-of-complaint-validation', this.qmsService.ccDropDowns.selectedSourceOfComplaint);
  }

  onSourceOfComplaintDeSelect() {
    this.handleDropDownValidation('source-of-complaint-validation', this.qmsService.ccDropDowns.selectedSourceOfComplaint);
  }

  onQaUserSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('qa-user-validation', item);
  }

  onQaUserSelectOld(item: any) {
    this.handleDropDownValidation('qa-user-validation', this.qmsService.ccDropDowns.selectedQA);
  }

  onQaUserRemoved(item: any) {
    this.handleDropDownValidation('qa-user-validation', this.qmsService.ccDropDowns.selectedQA);
  }

  selectBoxForEvaluator() {
    this.evaluatorDropDown = [];
    this.evaluatorDropDown = this.dropDownForEvaluator?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  selectBoxForCompanyComplaintType() {
    this.companyComplaintTypeDropDown = [];
    this.companyComplaintTypeDropDown = this.dropDownForCompanyComplaintType.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onCompanyComplaintTypeSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('initial-company-complaint-type-validation', item);
  }

  onCompanyComplaintTypeSelectOld() {
    this.handleDropDownValidation('initial-company-complaint-type-validation', this.qmsService.ccDropDowns.selectedCompanyComplaintType);
  }

  onCompanyComplaintTypeDeSelect() {
    this.handleDropDownValidation('initial-company-complaint-type-validation', this.qmsService.ccDropDowns.selectedCompanyComplaintType);
  }

  onIsProductComplaintChange(event: any) {
    this.ccData.immediateActionTaken = "";
    this.ccData.isInvestigationReqd = false;
    this.ccData.investigationTechniqueIfOthers = "";
  }

  onIsInvestigationRequiredChange(event: any) {
    [this.qmsService.ccDropDowns.selectedInvestigator, this.qmsService.ccDropDowns.selectedInvestigationTechnique, this.qmsService.ccDropDowns.selectedMarketAction] = [null, null, null];
    this.ccData.investigationReferenceNumber = null;
    this.ccData.investigationPlan = "";
    this.ccData.investigationDetails = "";
  }

  selectBoxForInvestigator() {
    this.investigatorDropDown = [];
    this.investigatorDropDown = this.dropDownForInvestigator?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onInvestigatorSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('investigator-validation', item);
  }

  onInvestigatorSelectOld() {
    this.handleDropDownValidation('investigator-validation', this.qmsService.ccDropDowns.selectedInvestigator);
  }

  onInvestigatorDeSelect() {
    this.handleDropDownValidation('investigator-validation', this.qmsService.ccDropDowns.selectedInvestigator);
  }

  selectBoxForInvestigationTechnique() {
    this.investigationTechniqueDropDown = [];
    this.investigationTechniqueDropDown = this.dropDownForInvestigationTechnique?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onInvestigationTechniqueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.showInvestigationIfOthers = item.displayExp === 'Others';
        if (this.showInvestigationIfOthers) this.ccData.investigationTechniqueIfOthers = "";
        this.handleDropDownValidation('investigation-technique-validation', item);
      }
    }
  }

  onInvestigationTechniqueSelectOld(item: any) {
    this.showInvestigationIfOthers = item.displayExp === 'Others';
    if (this.showInvestigationIfOthers) this.qmsService.activity.investigationTechniqueIfOthers = "";
    this.handleDropDownValidation('investigation-technique-validation', this.qmsService.ccDropDowns.selectedInvestigationTechnique);
  }

  onInvestigationTechniqueDeselect() {
    this.showInvestigationIfOthers = false;
    this.handleDropDownValidation('investigation-technique-validation', this.qmsService.ccDropDowns.selectedInvestigationTechnique);
  }

  onIsMarketActionRequiredChange(event: any) {
    this.showMarketAction = event.checked;
    this.qmsService.ccDropDowns.selectedMarketAction = null;
  }

  selectBoxForMarketAction() {
    this.marketActionDropDown = [];
    this.marketActionDropDown = this.dropDownForMarketAction?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onMarketActionSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('market-action-validation', item);
  }

  selectBoxForFinalComplaintCategory() {
    this.finalComplaintCategoryDropDown = [];
    this.finalComplaintCategoryDropDown = this.dropDownForFinalComplaintCategory?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onFinalComplaintCategorySelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('final-complaint-category-validation', this.qmsService.ccDropDowns.selectedFinalComplaintCategory);
        this.finalComplaintCategorySelection = this.reportedComplaintTypeDropDown.length == this.qmsService.ccDropDowns.selectedFinalComplaintCategory.length;
      })
  }

  onFinalComplaintCategorySelectOld() {
    this.handleDropDownValidation('final-complaint-category-validation', this.qmsService.ccDropDowns.selectedFinalComplaintCategory);
  }

  onFinalComplaintCategoryDeSelect() {
    this.handleDropDownValidation('final-complaint-category-validation', this.qmsService.ccDropDowns.selectedFinalComplaintCategory);
  }

  onFinalComplaintCategorySelectAll(item: any[]) {
    this.handleDropDownValidation('final-complaint-category-validation', item);
  }

  onFinalComplaintCategoryDeSelectAll(item: any[]) {
    this.handleDropDownValidation('final-complaint-category-validation', item);
  }

  selectBoxForFinalCompanyComplaintType() {
    this.finalCompanyComplaintTypeDropDown = [];
    this.finalCompanyComplaintTypeDropDown = this.dropDownForFinalCompanyComplaintType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onFinalComplaintTypeSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('final-complaint-type-validation', item);
  }

  onFinalComplaintTypeSelectOld() {
    this.handleDropDownValidation('final-complaint-type-validation', this.qmsService.ccDropDowns.selectedFinalCompanyComplaintType);
  }

  onFinalComplaintTypeDeSelect() {
    this.handleDropDownValidation('final-complaint-type-validation', this.qmsService.ccDropDowns.selectedFinalCompanyComplaintType);
  }

  onIsResponseRequestedByConsumerChange(event: any) {
    this.qmsService.ccDropDowns.selectedMethodOfResponse = [];
    this.ccData.dateOfResponse = "";
  }

  onReimbursementRequestedChange(event: any) {
    this.qmsService.ccDropDowns.selectedReimbursementType = null;
    this.ccData.reimbursedAmount = null;
    this.ccData.reimbursemntRequestedDate = null;
    this.ccData.reimbursemntInitiatedDate = null;
    this.ccData.attempts = null;
    this.ccData.reasonForNoshow = "";
  }

  selectBoxForReimbursementStatus() {
    this.reimbursementStatusDropDown = [];
    this.reimbursementStatusDropDown = this.dropDownForReimbursementStatus?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onReimbursementStatusSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('reimbursement-status-validation', item);
  }

  onReimbursementStatusSelectOld() {
    this.handleDropDownValidation('reimbursement-status-validation', this.qmsService.ccDropDowns.selectedReimbursementStatus);
  }

  onReimbursementStatusDeSelect() {
    this.handleDropDownValidation('reimbursement-status-validation', this.qmsService.ccDropDowns.selectedReimbursementStatus);
  }

  selectBoxForReimbursementType() {
    this.reimbursementTypeDropDown = [];
    this.reimbursementTypeDropDown = this.dropDownForReimbursementType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onReimbursementTypeSelect() {
    this.handleDropDownValidation('reimbursement-type-validation', this.qmsService.ccDropDowns.selectedReimbursementType);
  }

  onReimbursementTypeDeSelect() {
    this.handleDropDownValidation('reimbursement-type-validation', this.qmsService.ccDropDowns.selectedReimbursementType);
  }

  selectBoxForResponseStatus() {
    this.responseStatusDropDown = [];
    this.responseStatusDropDown = this.dropDownForResponseStatus?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onResponseStatusSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('response-status-validation', item);
  }

  onResponseStatusSelectOld() {
    this.handleDropDownValidation('response-status-validation', this.qmsService.ccDropDowns.selectedResponseStatus);
  }

  onResponseStatusDeSelect() {
    this.handleDropDownValidation('response-status-validation', this.qmsService.ccDropDowns.selectedResponseStatus);
  }

  selectBoxForMethodOfResponse() {
    // First build the regular dropdown from available options
    const regularOptions = this.dropDownForMethodOfResponse?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? [];

    // Keep any missing values that were added during optimization
    const missingOptions = this.methodOfResponseDropDown.filter((item: any) => item.isMissing) || [];

    // Combine regular and missing options
    this.methodOfResponseDropDown = [...regularOptions, ...missingOptions];
  }

  onMethodOfResponseSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('method-of-response-validation', this.qmsService.ccDropDowns.selectedMethodOfResponse);
        this.methodOfResponseSelection = this.methodOfResponseDropDown.length == this.qmsService.ccDropDowns.selectedMethodOfResponse.length;
      })
    }
  }

  onMethodOfResponseSelectOld() {
    this.handleDropDownValidation('method-of-response-validation', this.qmsService.ccDropDowns.selectedMethodOfResponse);
  }

  onMethodOfResponseDeSelect() {
    this.handleDropDownValidation('method-of-response-validation', this.qmsService.ccDropDowns.selectedMethodOfResponse);
  }

  @ViewChild('initialComplaintCategory') initialComplaintCategory: MatSelect;
  initialComplaintCategorySelection = false;
  @ViewChild('finalComplaintCategory') finalComplaintCategory: MatSelect;
  finalComplaintCategorySelection = false;
  @ViewChild('department') department: MatSelect;
  departmentSelection = false;
  @ViewChild('methodOfResponse') methodOfResponse: MatSelect;
  methodOfResponseSelection = false;

  toggleAllSelection(value: any) {
    if (value == 'initialComplaintCategory') {
      if (this.initialComplaintCategorySelection) this.initialComplaintCategory.options.forEach((item: MatOption) => item.select());
      else {
        this.initialComplaintCategory.options.forEach((item: MatOption) => item.deselect())
        this.qmsService.ccDropDowns.selectedReportedComplaintType = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('initial-complaint-category-validation', this.qmsService.ccDropDowns.selectedReportedComplaintType)
      });

    } else if (value == 'finalComplaintCategory') {
      if (this.finalComplaintCategorySelection) this.finalComplaintCategory.options.forEach((item: MatOption) => item.select());
      else {
        this.finalComplaintCategory.options.forEach((item: MatOption) => item.deselect())
        this.qmsService.ccDropDowns.selectedFinalComplaintCategory = [];
      }

      setTimeout(() => {
        this.handleDropDownValidation('final-complaint-category-validation', this.qmsService.ccDropDowns.selectedFinalComplaintCategory)
      });

    } else if (value == 'department') {
      if (this.departmentSelection) this.department.options.forEach((item: MatOption) => item.select());
      else {
        this.department.options.forEach((item: MatOption) => item.deselect())
        this.qmsService.ccDropDowns.selectedDepartment = [];
      }
    } else if (value == 'methodOfResponse') {
      if (this.methodOfResponseSelection) this.methodOfResponse.options.forEach((item: MatOption) => item.select());
      else {
        this.methodOfResponse.options.forEach((item: MatOption) => item.deselect())
        this.qmsService.ccDropDowns.selectedMethodOfResponse = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('method-of-response-validation', this.qmsService.ccDropDowns.selectedMethodOfResponse)
      });
    }
  }

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    adaptivePosition: true
  }

  dateOfOccurrenceConfig = {
    maxDate: new Date(),
    ...this.commonDateConfig
  }

  reportedDateConfig() {
    return {
      minDate: new Date(this.qmsService.activity.dateOfOccurrence),
      maxDate: new Date(),
      ...this.commonDateConfig
    }
  }

  expectedClosureConfig = {
    minDate: new Date(),
    ...this.commonDateConfig
  }

  onDateOfOccurrenceChange() {
    if (!this.qmsService.activity.dateOfOccurrence) this.qmsService.activity.dateReported = null;
  }

  reimburseInitiatedDateConfig() {
    return {
      minDate: new Date(this.qmsService.activity.reimbursemntRequestedDate),
      //maxDate: new Date(),
      ...this.commonDateConfig
    }
  }

  dateTimeConfig = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };


  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Reporter Comments': this.dynamicLabel?.['REPORTER_COMMENTS']?.fieldName,
      'Complaint Description': this.dynamicLabel?.['COMPLAINT_DESCRIPTION']?.fieldName,
      'Initial Assessment': this.dynamicLabel?.['INITIAL_ASSESSMENT']?.fieldName,
      'Immediate Action Taken': this.dynamicLabel?.['IMMEDIATE_ACTION_TAKEN']?.fieldName,
      'Action Items Required': this.dynamicLabel?.['ACTION_ITEMS_REQD']?.fieldName,
      'Investigation Plan': this.dynamicLabel?.['INVESTIGATION_PLAN']?.fieldName,
      'Investigation Details': this.dynamicLabel?.['INVESTIGATION_DETAILS']?.fieldName,
      'Investigation Technique (If Others)': this.dynamicLabel?.['INVESTIGATION_TECHNIQUE_IF_OTHERS']?.fieldName,
      'Closure Comments': this.dynamicLabel?.['CLOSURE_COMMENTS']?.fieldName,
      'Reason for No Show': this.dynamicLabel?.['REASON_FOR_NOSHOW']?.fieldName,
      'Resolution Comments': this.dynamicLabel?.['RESOLUTION_COMMENTS']?.fieldName,
      'Response Summary': this.dynamicLabel?.['RESPONSE_SUMMARY']?.fieldName,
      'Reason for Noshow': this.dynamicLabel?.['REASON_FOR_NOSHOW']?.fieldName
    };

    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qmsService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qmsService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };


  validateMobileNumber(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  numberValidation(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '.', '+'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      100: ['REPORTER_STATE', 'REPORTER_CITY', 'REPORTER_FAX', 'REPORTER_CONTACT_NUMBER_OFFICE', 'REPORTER_CONTACT_NUMBER', 'REPORTER_ZIPCODE'],
      200: ['REPORTER_FIRST_NAME', 'REPORTER_MIDDLE_NAME', 'EMAIL_ADDRESS', 'REPORTER_LAST_NAME',],
      400: ['REPORTER_ADDRESS1', 'REPORTER_ADDRESS2'], 2000: ['LOCATION_IF_OTHERS']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = limit;
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'initial-complaint-category-validation' || fieldId === 'final-complaint-category-validation' || fieldId === 'method-of-response-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = tempDiv.textContent ?? tempDiv.innerText ?? '';
    return textContent.trim().length === 0;
  }

  onStEditorChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    let isEmpty: boolean = false;
    items && (isEmpty = this.isContentEmpty(items));
    field && (field.style.color = isEmpty ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  checkRequestDate(items: any, fieldId: string) {
    if ((this.qmsService.activity.reimbursemntInitiatedDate && this.qmsService.activity.reimbursemntInitiatedDate < this.qmsService.activity.reimbursemntRequestedDate) ||
      !this.qmsService.activity.reimbursemntRequestedDate) {
      this.qmsService.activity.reimbursemntInitiatedDate = null;
    }
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element && (element.style.color = 'red');
    });
  }

  async update(): Promise<boolean> {
    const ccParam = this.qmsService.activity;

    this.qmsService.validatedCcArray = [];
    let validationPromises: Promise<void>[] = [];
    const isInitiator = this.qmsService.activity.initiator == this.message.getUserId();
    const isEvaluator = this.qmsService.activity.evaluator == this.message.getUserId();
    const isInvestigator = this.qmsService.activity.investigator == this.message.getUserId();
    const ccHandler = this.qmsService.selectedGroupDetailData.activityHandler;
    const status = this.qmsService.activity.status;

    if (!this.skipValidationsWhileSwitchingUser) {
      if (isInitiator && status == 'Draft' || status == 'More Information Requested By Evaluator') {
        validationPromises.push(this.validateComplainantDetails(), this.validateComplaintDates());
      } else if (isEvaluator && (status == 'Complaint Accepted' || status == 'Logged' || status == 'Reviewer Requested More Info.' || status == 'Review Rejected' || status == 'Approver Requested More Info.' || status == 'Approval Rejected' || status == 'Closure Reviewer Requested More Info.' || status == 'Closure Review Rejected' || status == 'Closure Approver Requested More Info.' || status == 'Closure Approval Rejected')) {
        validationPromises.push(this.validateComplainantDetails(), this.validateComplaintDates(), this.validateComplaintIdentification());
      } else if (isInvestigator && (status == 'Investigation Pending' || status == 'Reinvestigation Requested')) {
        validationPromises.push(this.validateComplaintInvestigation());
      } else if ((ccHandler == 'Evaluator' ? isEvaluator : isInvestigator) && (status == 'In Progress')) {
        validationPromises.push(this.validateComplainantDetails(), this.validateComplaintDates(), this.validateComplaintIdentification(), this.validateComplaintFinalEvaluation());
        this.qmsService.activity.isReimbursementReqd && validationPromises.push(this.validateComplaintReimbursement());
        this.qmsService.activity.isReponseRequestedByCustomer && validationPromises.push(this.validateComplaintResponse());
      }
    }

    try {
      await Promise.all(validationPromises);

      const isValid = !this.qmsService.validatedCcArray.includes('Failed');
      if (isValid) {
        const obj = await this.prepareObj(ccParam);
        const result = await this.execute(obj);
        return result;
      } else {
        this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
        return false;
      }
    } catch (error) {
      console.error('Error occurred during validation:', error);
      return false;
    }
  }

  private formatDate(date?: any): string | null {
    return date ? this.appService.dateZoneConvertion(new Date(date)) : null;
  }

  private mapBooleanToYN(value?: boolean): 'Y' | 'N' {
    return value ? 'Y' : 'N';
  }

  private mapArrayToString(x: any[]): string | null {
    return x?.length ? x?.join(',') : null;
  }

  async prepareObj(ccParam: any): Promise<any> {
    return {
      groupId: this.qmsService.selectedActivityGroupId,
      ccNo: this.ccData.ccNo,
      reportedComplaintType: this.mapArrayToString(this.qmsService.ccDropDowns.selectedReportedComplaintType),
      natureOfComplaint: this.qmsService.ccDropDowns.selectedNatureOfComplaint ?? null,
      dateOfOccurrence: this.formatDate(ccParam.dateOfOccurrence),
      dateReported: this.formatDate(ccParam.dateReported),
      expcetedClosureOn: this.formatDate(ccParam.expcetedClosureOn),
      actionItemsReqd: this.mapBooleanToYN(ccParam.actionItemsReqd),
      preActionItemsReqd: this.mapBooleanToYN(ccParam.preActionItemsReqd),
      reporterTitle: this.qmsService.ccDropDowns.selectedReporterTitle ?? null,
      reporterFirstName: ccParam.reporterFirstName,
      reporterMiddleName: ccParam.reporterMiddleName,
      reporterLastName: ccParam.reporterLastName,
      reporterType: this.qmsService.ccDropDowns.selectedReporterType ?? null,
      reporterDesignation: ccParam.reporterDesignation,
      reporterAddress1: ccParam.reporterAddress1,
      reporterAddress2: ccParam.reporterAddress2,
      reporterContactNumber: ccParam.reporterContactNumber,
      reporterContactNumberOffice: ccParam.reporterContactNumberOffice,
      emailAddress: ccParam.emailAddress,
      reporterFax: ccParam.reporterFax,
      reporterCity: ccParam.reporterCity,
      reporterState: ccParam.reporterState,
      reporterCountry: this.qmsService.ccDropDowns.selectedReporterCountry ?? null,
      reporterZipcode: ccParam.reporterZipcode,
      reporterComments: ccParam.reporterComments ?? 'c',
      deptCode: this.mapArrayToString(this.qmsService.ccDropDowns.selectedDepartment),
      locationIfOthers: ccParam.locationIfOthers,
      evaluator: this.qmsService.ccDropDowns.selectedEvaluator ?? null,
      sourceOfComplaint: this.qmsService.ccDropDowns.selectedSourceOfComplaint ?? null,
      complaintDescription: ccParam.complaintDescription,
      initialAssessment: ccParam.initialAssessment,
      isProductComplaint: this.mapBooleanToYN(ccParam.isProductComplaint),
      companyComplaintType: this.qmsService.ccDropDowns.selectedCompanyComplaintType ?? null,
      immediateActionTaken: ccParam.immediateActionTaken,
      isInvestigationReqd: this.mapBooleanToYN(ccParam.isInvestigationReqd),
      investigator: this.qmsService.ccDropDowns.selectedInvestigator ?? null,
      investigationReferenceNumber: ccParam.investigationReferenceNumber,
      finalCompanyComplaintType: this.qmsService.ccDropDowns.selectedFinalCompanyComplaintType ?? null,
      isMarketActionReqd: this.mapBooleanToYN(ccParam.isMarketActionReqd),
      marketActionReqd: this.qmsService.ccDropDowns.selectedMarketAction ? this.qmsService.ccDropDowns.selectedMarketAction : null,
      closureComments: ccParam.closureComments,
      isReponseRequestedByCustomer: this.mapBooleanToYN(ccParam.isReponseRequestedByCustomer),
      isSampleReturned: this.mapBooleanToYN(ccParam.isSampleReturned),
      responseSummary: ccParam.responseSummary,
      methodOfResponse: this.mapArrayToString(this.qmsService.ccDropDowns.selectedMethodOfResponse),
      dateOfResponse: this.formatDate(ccParam.dateOfResponse),
      responseStatus: this.qmsService.ccDropDowns.selectedResponseStatus ?? null,
      complaintAcceptedOrJustification: ccParam.complaintAcceptedOrJustification,
      finalComplaintCategory: this.mapArrayToString(this.qmsService.ccDropDowns.selectedFinalComplaintCategory),
      investigationPlan: ccParam.investigationPlan,
      investigationDetails: ccParam.investigationDetails,
      investigationTechniqueIfOthers: ccParam.investigationTechniqueIfOthers,
      investigationTechnique: this.qmsService.ccDropDowns.selectedInvestigationTechnique ?? null,
      locationDetails: this.qmsService.ccDropDowns.selectedLocations ?? null,
      isReimbursementReqd: this.mapBooleanToYN(ccParam.isReimbursementReqd),
      reimbursementType: this.qmsService.ccDropDowns.selectedReimbursementType ?? null,
      reimbursedAmount: ccParam.reimbursedAmount,
      reimbursemntRequestedDate: this.formatDate(ccParam.reimbursemntRequestedDate),
      reimbursemntInitiatedDate: this.formatDate(ccParam.reimbursemntInitiatedDate),
      reimbursementTrackingDetails: ccParam.reimbursementTrackingDetails,
      reimbursemntReceivedDate: this.formatDate(ccParam.reimbursemntReceivedDate),
      reimbursementStatus: this.qmsService.ccDropDowns.selectedReimbursementStatus ?? null,
      attempts: ccParam.attempts,
      reasonForNoshow: ccParam.reasonForNoshow,
      resolutionComments: ccParam.resolutionComments,
      isRiskCalculationReqd: this.mapBooleanToYN(ccParam.isRiskCalculationReqd),
      raisedFrom: ccParam.raisedFrom,
      qaUser: (this.ccData.qaUser != 0 && this.qmsService.ccDropDowns.selectedQA) ? this.qmsService.ccDropDowns.selectedQA : null,
    };
  }

  execute(obj: any): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.isProcessing = true;

      this.appService.updateComplaint(obj).subscribe({
        next: (Response: any) => {
          this.message.lastmsg = Response;

          if (Response.resultType === 'S') {
            this.ngOnInit();
            if (this.skipValidationsWhileSwitchingUser) {
              this.skipValidationsWhileSwitchingUser = false;
            } else if (this.flexibleComponent.flexibleFields.length) {
              this.flexibleComponent.save('activity', this.qmsService.activityId);
            }

            if (this.qmsService.isUpdatingCcThroughDynBtn) {
              this.qmsService.isUpdatingCcThroughDynBtn = false;
            } else {
              this.showSnackBar(Response.result, Response.resultType);
            }
            resolve(true);
          } else {
            this.showSnackBar(Response.result, Response.resultType);
            resolve(false);
          }
          this.isProcessing = false;
        },
        error: (error: Error) => {
          this.isProcessing = false;
          console.error('Execution error:', error);
          reject(new Error('Error Occurred'));
        }
      });
    });
  }

  async validateComplainantDetails(): Promise<void> {
    const validations = [
      { condition: this.dynamicLabel['REPORTER_TITLE'].isRemovable != 'Y' && !this.qmsService.ccDropDowns.selectedReporterTitle, id: 'title-validation' },
      { condition: !this.qmsService.activity.reporterFirstName, id: 'first-name-validation' },
      { condition: !this.qmsService.activity.reporterLastName && this.dynamicLabel['REPORTER_LAST_NAME'].isRemovable != 'Y', id: 'last-name-validation' },
      { condition: this.dynamicLabel['REPORTER_TYPE'].isRemovable != 'Y' && !this.qmsService.ccDropDowns.selectedReporterType, id: 'reporter-type-validation' },
      { condition: !this.qmsService.activity.reporterComments || this.isContentEmpty(this.qmsService.activity.reporterComments), id: 'comments' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateComplaintDates(): Promise<void> {
    const validations = [
      { condition: !this.qmsService.activity.dateOfOccurrence, id: 'date-reported-validation' },
      { condition: !this.qmsService.activity.dateReported, id: 'date-of-occurrence-validation' },
      { condition: !this.qmsService.activity.expcetedClosureOn, id: 'expected-closure-on-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateComplaintIdentification(): Promise<void> {
    const validations = [
      { condition: !this.qmsService.ccDropDowns.selectedNatureOfComplaint && this.dynamicLabel['NATURE_OF_COMPLAINT']?.isRemovable != 'Y', id: 'nature-of-complaint-validation' },
      { condition: this.qmsService.ccDropDowns.selectedReportedComplaintType?.length < 1 && this.dynamicLabel['REPORTED_COMPLAINT_TYPE']?.isRemovable != 'Y', id: 'initial-complaint-category-validation' },
      { condition: !this.qmsService.ccDropDowns.selectedSourceOfComplaint && this.dynamicLabel['SOURCE_OF_COMPLAINT']?.isRemovable != 'Y', id: 'source-of-complaint-validation' },
      { condition: !this.qmsService.activity.complaintDescription || this.isContentEmpty(this.qmsService.activity.complaintDescription), id: 'complaint-description-validation' },
      { condition: !this.qmsService.activity.initialAssessment || this.isContentEmpty(this.qmsService.activity.initialAssessment), id: 'initial-assessment-validation' },
      { condition: this.qmsService.activity.isProductComplaint && !this.qmsService.ccDropDowns.selectedCompanyComplaintType, id: 'initial-company-complaint-type-validation' },
      { condition: this.qmsService.activity.isInvestigationReqd && !this.qmsService.ccDropDowns.selectedInvestigator, id: 'investigator-validation' },
      { condition: this.ccData.qaUser != 0 && !this.qmsService.ccDropDowns.selectedQA, id: 'qa-user-validation' }
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateComplaintInvestigation(): Promise<void> {
    const validations = [
      { condition: this.dynamicLabel['INVESTIGATION_REFERENCE_NUMBER'].isRemovable != 'Y' && !this.qmsService.activity.investigationReferenceNumber, id: 'investigation-ref-no-validation' },
      { condition: this.dynamicLabel['INVESTIGATION_PLAN'].isRemovable != 'Y' && (!this.qmsService.activity.investigationPlan || this.isContentEmpty(this.qmsService.activity.investigationPlan)), id: 'investigation-plan-validation' },
      { condition: !this.qmsService.activity.investigationDetails || this.isContentEmpty(this.qmsService.activity.investigationDetails), id: 'investigation-details-validation' },
      { condition: this.dynamicLabel['INVESTIGATION_TECHNIQUE'].isRemovable != 'Y' && !this.qmsService.ccDropDowns.selectedInvestigationTechnique, id: 'investigation-technique-validation' },
      { condition: this.dynamicLabel['INVESTIGATION_TECHNIQUE_IF_OTHERS'].isRemovable != 'Y' && this.showInvestigationIfOthers && !this.qmsService.activity.investigationTechniqueIfOthers, id: 'investigation-technique-if-others-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateComplaintFinalEvaluation(): Promise<void> {
    const validations = [
      { condition: !this.qmsService.activity.complaintAcceptedOrJustification, id: 'complaint-accepted-validation' },
      { condition: this.qmsService.activity.isMarketActionReqd && !this.qmsService.ccDropDowns.selectedMarketAction, id: 'market-action-validation' },
      { condition: this.qmsService.ccDropDowns.selectedFinalComplaintCategory.length < 1 && this.dynamicLabel['FINAL_COMPLAINT_CATEGORY']?.isRemovable != 'Y', id: 'final-complaint-category-validation' },
      { condition: !this.qmsService.ccDropDowns.selectedFinalCompanyComplaintType, id: 'final-complaint-type-validation' },
      { condition: this.dynamicLabel['CLOSURE_COMMENTS'].isRemovable != 'Y' && (!this.qmsService.activity.closureComments || this.isContentEmpty(this.qmsService.activity.closureComments)), id: 'closure-comments-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateComplaintReimbursement(): Promise<void> {
    const validations = [
      { condition: !this.qmsService.ccDropDowns.selectedReimbursementStatus, id: 'reimbursement-status-validation' },
      { condition: !this.qmsService.ccDropDowns.selectedReimbursementType && this.dynamicLabel['REIMBURSEMENT_TYPE']?.isRemovable != 'Y', id: 'reimbursement-type-validation' },
      { condition: !this.qmsService.activity.reimbursemntRequestedDate, id: 'requested-date-validation' },
      { condition: !this.qmsService.activity.reimbursemntInitiatedDate, id: 'initiated-date-validation' },
      { condition: this.dynamicLabel['RESOLUTION_COMMENTS'].isRemovable != 'Y' && (!this.qmsService.activity.resolutionComments || this.isContentEmpty(this.qmsService.activity.resolutionComments)), id: 'resolution-comments-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateComplaintResponse(): Promise<void> {
    const validations = [
      { condition: !this.qmsService.ccDropDowns.selectedResponseStatus, id: 'response-status-validation' },
      { condition: !this.qmsService.ccDropDowns.selectedMethodOfResponse?.length, id: 'method-of-response-validation' },
      { condition: !this.qmsService.activity.dateOfResponse, id: 'date-of-response-validation' },
      { condition: this.dynamicLabel['RESPONSE_SUMMARY'].isRemovable != 'Y' && (!this.qmsService.activity.responseSummary || this.isContentEmpty(this.qmsService.activity.responseSummary)), id: 'response-summary-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  isFinalEvaluationFailed: boolean = false;
  isReimbursementFailed: boolean = false;
  isResponseFailed: boolean = false;
  private async handleAsyncValidation(validations: { condition: boolean, id: string }[]): Promise<void> {

    const invalidIds: string[] = validations.filter(v => v.condition).map(v => v.id);

    if (!this.isFinalEvaluationFailed) {
      const finalEvaluationIds = ['complaint-accepted-validation', 'market-action-validation', 'final-complaint-category-validation', 'final-complaint-type-validation', 'closure-comments-validation']
      this.isFinalEvaluationFailed = finalEvaluationIds.some(id => invalidIds.includes(id));
    }

    if (!this.isReimbursementFailed) {
      const reimbursementIds = ['reimbursement-status-validation', 'reimbursement-type-validation', 'requested-date-validation', 'initiated-date-validation', 'resolution-comments-validation']
      this.isReimbursementFailed = reimbursementIds.some(id => invalidIds.includes(id));
    }

    if (!this.isResponseFailed) {
      const responseIds = ['response-status-validation', 'method-of-response-validation', 'date-of-response-validation', 'response-summary-validation']
      this.isResponseFailed = responseIds.some(id => invalidIds.includes(id));
    }

    this.qmsService.validatedCcArray.push(invalidIds.length > 0 ? 'Failed' : 'Passed')
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    }
  }

  getFailedTabs(): string {
    const failedTabs = [
      this.isFinalEvaluationFailed ? 'Final Evaluation' : '', this.isReimbursementFailed ? 'Reimbursement' : '', this.isResponseFailed ? 'Response' : ''
    ].filter(item => !!item);

    return failedTabs.join(', ');
  }

  @ViewChild('topicPopup', { static: false }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('taskActionHistoryPopup', { static: true }) taskActionHistoryPopup: TemplateRef<any>;
  visibleTaskActionHistoryPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  taskActionHistoryPopupConfig = {
    width: '130%',
    height: '100%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  openTopicPopup() {
    this.message.communicatingFrom = this.qmsService.moduleName;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  cancelTopicPopup() {
    this.visibleTopicPopup.close();
  }

  openTaskActionsHistory() {
    this.taskActionsHistoryComponent.ngOnInit();
    this.visibleTaskActionHistoryPopup = this.dialog.open(this.taskActionHistoryPopup, this.taskActionHistoryPopupConfig);
  }

  cancelTaskActionHistoryPopup() {
    this.visibleTaskActionHistoryPopup.close();
  }

  closeMandatoryPopup() {
    this.isFinalEvaluationFailed = this.isReimbursementFailed = this.isResponseFailed = false;
    this.visibleMandatoryPopup.close();
  }

  statusDependentAesthetic() {
    const { initiator, evaluator, qaUser, investigator, isInvestigationReqd, status, preActionItemsReqd, actionItemsReqd, isProductComplaint, isReimbursementReqd, isReponseRequestedByCustomer, isRiskCalculationReqd } = this.qmsService.activity;

    const loggedUserId = this.message.getUserId();
    const isInitiator = initiator == loggedUserId;
    const isEvaluator = evaluator == loggedUserId;
    const isQa = qaUser == loggedUserId;
    const isEditableByQa = this.qmsService.selectedGroupDetailData.editableByQA == "Y";
    const ccHandler = this.qmsService.selectedGroupDetailData.activityHandler;
    const isInvestigator = investigator == loggedUserId;
    const isEditableByInvestigator = this.qmsService.selectedGroupDetailData.editableByInvestigator == "Y";
    const isInvestigation = isInvestigationReqd;
    const isActions = actionItemsReqd;
    const isPreActions = preActionItemsReqd;
    const isRisk = isRiskCalculationReqd && this.qmsService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';
    const isProduct = isProductComplaint;
    const isReimbursement = isReimbursementReqd;
    const isResponse = isReponseRequestedByCustomer;
    const isReviewer = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == loggedUserId);
    const isEditableByReviewer = this.qmsService.selectedGroupDetailData.editableByReviewers == "Y";
    const isApprover = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == loggedUserId);
    const isEditableByApprover = this.qmsService.selectedGroupDetailData.editableByApprovers == "Y";

    this.elite_toggle = isEvaluator && (status == "QA Rejected" || status == "QA Approved");
    if (!this.elite_toggle) {
      this.elite_toggle = ((ccHandler == 'Evaluator' || !isInvestigation) ? isEvaluator : isInvestigator) && (status == "Investigation Completed" || status == "Reviewer Requested More Info." || status == "Review Rejected" || status == "Approver Requested More Info." || status == "Approval Rejected" || status == "Closure Reviewer Requested More Info." || status == "Closure Review Rejected" || status == "Closure Approver Requested More Info." || status == "Closure Approval Rejected" || status == "Investigator Requested More Information");
    }
    this.qmsService.elite_AccessToClosure_Reviewer_Approver = status == "In Progress" && ((ccHandler == 'Evaluator' || !isInvestigation) ? isEvaluator : isInvestigator);
    this.elite_Investigation = isEvaluator && (status == "QA Approved");

    this.showParallelWorkflowAddButton = ((ccHandler == 'Evaluator' || !isInvestigation) ? isEvaluator : isInvestigator) && !this.parallelWorkflowList.length && status == 'In Progress';

    switch (status) {
      case 'Draft':
        this.draft_aesthetic(isInitiator, isPreActions, isRisk);
        break;

      case 'Deleted':
      case 'Raised':
      case 'Complaint Rejected - Closed':
        this.deleted_or_raised_or_closed_aesthetic(isPreActions, isRisk);
        break;

      case 'Complaint Accepted':
      case 'Logged':
      case 'QA Rejected':
        this.accepted_or_logged_QA_rejected_aesthetic(isEvaluator, isProduct, isPreActions, isActions, isRisk);
        break;

      case 'Pending QA Approval':
        this.pending_QA_aesthetic(isQa, isEditableByQa, isProduct, isPreActions, isActions, isRisk);
        break;

      case 'QA Approved':
        this.QA_approved_aesthetic(isEvaluator, isProduct, isPreActions, isActions, isRisk);
        break;

      case 'Investigation Pending':
      case 'Reinvestigation Requested':
        this.investigationPending_reInvestigation_aesthetic(isInvestigator, isEditableByInvestigator, isProduct, isPreActions, isActions, isRisk);
        break;

      case 'Investigator Requested More Information':
        this.investigator_req_more_info_aesthetic(isEvaluator, isProduct, isPreActions, isActions, isRisk);
        break;

      case 'Investigation Completed':
        this.investigationCompleted_aesthetic((ccHandler == 'Evaluator' || !isInvestigation) ? isEvaluator : isInvestigator, isProduct, isPreActions, isActions, isRisk);
        break;

      case 'Pending Review':
      case 'Review Inprogress':
        this.review_in_pending_or_inprogress_aesthetic(isInvestigation, isProduct, isPreActions, isActions, isRisk, isReviewer, isEditableByReviewer);
        break;

      case 'Pending Approval':
      case 'Approval Inprogress':
        this.approval_in_pending_or_inprogress_aesthetic(isInvestigation, isProduct, isPreActions, isActions, isRisk, isApprover, isEditableByApprover);
        break;

      case 'Reviewer Requested More Info.':
      case 'Review Rejected':
      case 'Approver Requested More Info.':
      case 'Approval Rejected':
        this.review_or_approval_in_moreInfo_or_rejected_aesthetic((ccHandler == 'Evaluator' || !isInvestigation) ? isEvaluator : isInvestigator, isInvestigation, isProduct, isPreActions, isActions, isRisk);
        break;

      case 'In Progress':
        this.inProgress_aesthetic({
          isEvaluatorOrInvestigator: (ccHandler == 'Evaluator' || !isInvestigation) ? isEvaluator : isInvestigator,
          isInvestigation,
          isProduct,
          isReimbursement,
          isResponse,
          isPreActions,
          isActions,
          isRisk
        });
        break;

      case 'Pending Closure Review':
      case 'Closure Review Inprogress':
      case 'Pending Closure Approval':
      case 'Closure Approval Inprogress':
      case 'Closed':
        this.closure_review_or_approval_in_pending_or_inprogress__or_closed_aesthetic(status, {
          isEvaluator,
          isInvestigation,
          isProduct,
          isReimbursement,
          isResponse,
          isPreActions,
          isActions,
          isRisk
        }); break;

      case 'Closure Reviewer Requested More Info.':
      case 'Closure Review Rejected':
      case 'Closure Approver Requested More Info.':
      case 'Closure Approval Rejected':
        {
          const closureConfig = {
            isEvaluator: (ccHandler == 'Evaluator' || !isInvestigation) ? isEvaluator : isInvestigator,
            isInvestigation,
            isProduct,
            isReimbursement,
            isResponse,
            isPreActions,
            isActions,
            isRisk
          };

          this.closure_review_or_approval_in_moreInfo_or_rejected_aesthetic(closureConfig);
          break;
        }
    }
    setTimeout(() => { this.flexibleComponent.main() });
  }


  setSwitchUserAesthetic(status: any, user: string): boolean {

    if (user == "evaluator") {
      this.qmsService.validSwitchStatus = status != 'Complaint Rejected - Closed';
      return this.qmsService.validSwitchStatus;
    } else {
      this.qmsService.validSwitchStatus = status != 'Complaint Rejected - Closed' && status != 'Closed'
      return this.qmsService.validSwitchStatus
    };
  }

  draft_aesthetic(isInitiator: boolean, isPreActions: boolean, isRisk: boolean) {
    this.message.showComplaintIdentificationSection = false;
    this.message.showInvestigationSection = false;
    this.message.showProductsTab = false;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = !isInitiator;
    this.isDateSectionFrozen = !isInitiator;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isInitiator;
    this.message.showActionSection = false;
    this.message.showActionsActionButtons = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isInitiator;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isInitiator;
  }

  deleted_or_raised_or_closed_aesthetic(isPreActions: boolean, isRisk: boolean) {
    this.message.showComplaintIdentificationSection = false;
    this.message.showInvestigationSection = false;
    this.message.showProductsTab = false;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = true;
    this.isDateSectionFrozen = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = false;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = false;
    this.message.showDependancySection = false;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = false;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = false;
  }

  accepted_or_logged_QA_rejected_aesthetic(isEvaluator: boolean, isProduct: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = false;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = isEvaluator;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = !isEvaluator;
    this.isDateSectionFrozen = !isEvaluator;
    this.isIdentificationSectionFrozen = !isEvaluator;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isEvaluator;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isEvaluator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isEvaluator;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isEvaluator;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isEvaluator;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isEvaluator;
  }

  pending_QA_aesthetic(isQa: boolean, isEditableByQa: boolean, isProduct: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = false;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = isQa && isEditableByQa;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = !(isQa && isEditableByQa);
    this.isDateSectionFrozen = !(isQa && isEditableByQa);
    this.isIdentificationSectionFrozen = !(isQa && isEditableByQa);
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isQa && isEditableByQa;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isQa && isEditableByQa;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isQa;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isQa && isEditableByQa;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isQa && isEditableByQa;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isQa && isEditableByQa;
  }

  QA_approved_aesthetic(isEvaluator: boolean, isProduct: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = false;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = isEvaluator;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = true;
    this.isDateSectionFrozen = true;
    this.isIdentificationSectionFrozen = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isEvaluator;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isEvaluator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isEvaluator;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isEvaluator;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isEvaluator;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isEvaluator;
  }

  investigationPending_reInvestigation_aesthetic(isInvestigator: boolean, isEditableByInvestigator: boolean, isProduct: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = isInvestigator;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = isInvestigator && isEditableByInvestigator;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = !(isInvestigator && isEditableByInvestigator);
    this.isDateSectionFrozen = true;
    this.isIdentificationSectionFrozen = !(isInvestigator && isEditableByInvestigator);
    this.isInvestigationSectionFrozen = !isInvestigator;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isInvestigator && isEditableByInvestigator;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isInvestigator && isEditableByInvestigator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isInvestigator;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isInvestigator && isEditableByInvestigator;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isInvestigator && isEditableByInvestigator;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isInvestigator && isEditableByInvestigator;
  }

  investigator_req_more_info_aesthetic(isEvaluator: boolean, isProduct: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = true;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = isEvaluator;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = true;
    this.isDateSectionFrozen = true;
    this.isIdentificationSectionFrozen = !isEvaluator;
    this.isInvestigationSectionFrozen = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isEvaluator;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isEvaluator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isEvaluator;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isEvaluator;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isEvaluator;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isEvaluator;
  }

  investigationCompleted_aesthetic(isEvaluatorOrInvestigator: boolean, isProduct: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = true;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = isEvaluatorOrInvestigator;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = true;
    this.isDateSectionFrozen = true;
    this.isIdentificationSectionFrozen = true;
    this.isInvestigationSectionFrozen = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isEvaluatorOrInvestigator;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isEvaluatorOrInvestigator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isEvaluatorOrInvestigator;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isEvaluatorOrInvestigator;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isEvaluatorOrInvestigator;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isEvaluatorOrInvestigator;
  }

  review_in_pending_or_inprogress_aesthetic(isInvestigation: boolean, isProduct: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean, isReviewer: boolean, isEditableByReviewer: boolean) {
    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = isInvestigation;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = isReviewer && isEditableByReviewer;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = !(isReviewer && isEditableByReviewer);
    this.isDateSectionFrozen = !(isReviewer && isEditableByReviewer);
    this.isIdentificationSectionFrozen = !(isReviewer && isEditableByReviewer);
    this.isInvestigationSectionFrozen = !(isReviewer && isEditableByReviewer);
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isReviewer && isEditableByReviewer;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isReviewer && isEditableByReviewer;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isReviewer;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isReviewer && isEditableByReviewer;;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isReviewer && isEditableByReviewer;
  }

  approval_in_pending_or_inprogress_aesthetic(isInvestigation: boolean, isProduct: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean, isApprover: boolean, isEditableByApprover: boolean) {
    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = isInvestigation;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = isApprover && isEditableByApprover;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = !(isApprover && isEditableByApprover);
    this.isDateSectionFrozen = !(isApprover && isEditableByApprover);
    this.isIdentificationSectionFrozen = !(isApprover && isEditableByApprover);
    this.isInvestigationSectionFrozen = !(isApprover && isEditableByApprover);
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isApprover && isEditableByApprover;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isApprover && isEditableByApprover;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isApprover;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isApprover && isEditableByApprover;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isApprover && isEditableByApprover;
  }

  review_or_approval_in_moreInfo_or_rejected_aesthetic(isEvaluator: boolean, isInvestigation: boolean, isProduct: boolean, isPreActions: boolean, isActions: boolean, isRisk: boolean) {
    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = isInvestigation;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = this.elite_toggle;
    this.message.showFinalEvaluationTab = false;
    this.message.showReimbursementTab = false;
    this.message.showResponseTab = false;
    this.isComplainantSectionFrozen = true;
    this.isDateSectionFrozen = true;
    this.isIdentificationSectionFrozen = true;
    this.isInvestigationSectionFrozen = true;
    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = isEvaluator;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isEvaluator;
    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isEvaluator;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isEvaluator;
    this.message.showExtensionSection = false;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isEvaluator;
    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isEvaluator;
  }

  inProgress_aesthetic(config: any) {
    const {
      isEvaluatorOrInvestigator,
      isInvestigation,
      isProduct,
      isReimbursement,
      isResponse,
      isPreActions,
      isActions,
      isRisk
    } = config;

    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = isInvestigation;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = false;
    this.message.showFinalEvaluationTab = true;
    this.message.showReimbursementTab = isReimbursement;
    this.message.showResponseTab = isResponse;

    this.isComplainantSectionFrozen = true;
    this.isDateSectionFrozen = true;
    this.isIdentificationSectionFrozen = true;
    this.isInvestigationSectionFrozen = true;
    this.isFinalEvalSectionFrozen = !isEvaluatorOrInvestigator;
    this.isReimbursementSectionFrozen = !isEvaluatorOrInvestigator;
    this.isResponseSectionFrozen = !isEvaluatorOrInvestigator;

    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;

    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;

    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isEvaluatorOrInvestigator;

    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isEvaluatorOrInvestigator;

    this.message.showExtensionSection = true;
    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;

    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = false;
  }

  closure_review_or_approval_in_pending_or_inprogress__or_closed_aesthetic(
    status: string,
    config: any
  ) {
    const {
      isEvaluator,
      isInvestigation,
      isProduct,
      isReimbursement,
      isResponse,
      isPreActions,
      isActions,
      isRisk
    } = config;

    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = isInvestigation;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = false;
    this.message.showFinalEvaluationTab = true;
    this.message.showReimbursementTab = isReimbursement;
    this.message.showResponseTab = isResponse;

    this.isComplainantSectionFrozen = true;
    this.isDateSectionFrozen = true;
    this.isIdentificationSectionFrozen = true;
    this.isInvestigationSectionFrozen = true;
    this.isFinalEvalSectionFrozen = true;
    this.isReimbursementSectionFrozen = true;
    this.isResponseSectionFrozen = true;

    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = false;

    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = status == 'Closed' && isEvaluator;

    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = false;
    this.message.showExtensionSection = true;

    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = false;

    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = false;
  }

  closure_review_or_approval_in_moreInfo_or_rejected_aesthetic(config: any) {
    const {
      isEvaluator,
      isInvestigation,
      isProduct,
      isReimbursement,
      isResponse,
      isPreActions,
      isActions,
      isRisk
    } = config;

    this.message.showComplaintIdentificationSection = true;
    this.message.showInvestigationSection = isInvestigation;
    this.message.showProductsTab = isProduct;
    this.message.showProductsActionButtons = this.elite_toggle;
    this.message.showFinalEvaluationTab = true;
    this.message.showReimbursementTab = isReimbursement;
    this.message.showResponseTab = isResponse;

    this.isComplainantSectionFrozen = true;
    this.isDateSectionFrozen = true;
    this.isIdentificationSectionFrozen = true;
    this.isInvestigationSectionFrozen = true;
    this.isFinalEvalSectionFrozen = true;
    this.isReimbursementSectionFrozen = true;
    this.isResponseSectionFrozen = true;

    this.message.showPreActionsTab = isPreActions;
    this.message.showPreActionsActionButtons = false;
    this.message.showActionSection = isActions;
    this.message.showActionsActionButtons = isEvaluator;

    this.message.showDocumentSection = true;
    this.message.showDocumentActionButtons = isEvaluator;
    this.message.showDependancySection = true;
    this.message.showDependencyActionButton = isEvaluator;
    this.message.showExtensionSection = true;

    this.message.showReviewApproveSection = true;
    this.message.showReviewApproveActionButtons = isEvaluator;

    this.message.showRiskTab = isRisk;
    this.qmsService.showRiskButtons = isEvaluator;
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe({
      next: () => {
        this.snackbarRef.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
      complete: () => { }
    })
  }


  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  //PDF report - start
  dropDownDataForReportTemplate: any = [];
  selectedReportTemplateValue: any = [];
  reportTemplateDropdown: any = [];

  selectBoxForReportTemplate() {
    this.reportTemplateDropdown = [];
    this.reportTemplateDropdown = this.dropDownDataForReportTemplate?.map((item: any) => ({
      valueExp: item.qmsReportTemplateVwPk.templateId,
      displayExp: item.templateName
    }))
  }

  templateId: number;
  onReportTemplateSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedReportTemplateValue = item.valueExp;
      this.templateId = item.valueExp;
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = '';
      }
    }
  }

  onReportTemplateRemoved(event: any) {
    if (event.isUserInput) {
      this.selectedReportTemplateValue = null;
      this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
      if (this.selectedReportTemplateValue.length == 0) {
        if (this.reportTemplateFieldValidation != undefined) {
          this.reportTemplateFieldValidation.style.color = 'red';
        }
      }
    }
  }
  openExportPopup() {
    this.selectedReportTemplateValue = null;
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();

    this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);
  }

  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  reportTemplateFieldValidation: any;
  exportReport() {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue) {
      /* Default template id for testing 17337; */
      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      let data1 = {
        "groupId": this.qmsService.activity.groupId + "",

        "gridName": "CC",
        "templateId": this.templateId,
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "attachAllDocuments": this.attachAllDocuments ? 'Y' : 'N',
        "footer": this.selectedReportFooter ?? null,
        "reportName": this.reportName ?? "QI_Report",
        "currentStatus": this.qmsService.activity.status,
        "groupName": thirdL[1],
        "CCid": this.message.activityId,
        "version": "0",
        "CCId": this.qmsService.activity.ccId
      }

      this.isProcessing = true;
      this.appService.genRateCCReport(data1).subscribe((response: any) => {

        const blob = new Blob([response.body], { type: "application/pdf" });
        let downloadURL = globalThis.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        const first = this.message.breadcrumbData.firstLevel;
        const second = this.message.breadcrumbData.secondLevel;
        const thirdL = this.message.breadcrumbData.thirdLevel;
        const fourthL = this.message.breadcrumbData.fourthLevel;

        let fileName = "";
        if (first != null) {
          fileName = first + "_";
        }
        if (second != null) {
          fileName = fileName + second + "_";
        }
        if (thirdL != null) {
          fileName = fileName + thirdL + "_";
        }
        if (fourthL != null) {
          fileName = fileName + fourthL + "_";
        }
        link.download = fileName + Date.now() + ".pdf";
        link.click();
        this.isProcessing = false;
      })
    } else {
      alert('Please enter the all mandatory fields...');
      this.reportTemplateFieldValidation.style.color = 'red';
    }
  }

  cancelReport() {
    this.visibleExportReportPopup.close();
  }

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qmsService.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qmsService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  @ViewChild(SwitchuserComponent) switchUserComponent!: SwitchuserComponent;

  async openSwitchUser(userBeingSwitched: any) {
    if (this.qmsService.activity.status == "In Progress" && userBeingSwitched != "Evaluator" && (userBeingSwitched == 'Investigator' && this.qmsService.selectedGroupDetailData.activityHandler != 'Investigator') && await this.qmsService.validateExtension({ refNo: this.qmsService.activityId, extensionFor: "Activity" })) {
      setTimeout(() => {
        this.showSnackBar(this.qmsService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false }
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = userBeingSwitched;
    if (userBeingSwitched == "Evaluator") {
      this.message.switchedUser = this.qmsService.ccDropDowns.selectedEvaluator;
      this.message.switchUserCurrentValue = this.qmsService.ccDropDowns.selectedEvaluator;
      this.message.switchUserdropDownList = this.evaluatorDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (userBeingSwitched == "Investigator") {
      this.message.switchedUser = this.qmsService.ccDropDowns.selectedInvestigator;
      this.message.switchUserCurrentValue = this.qmsService.ccDropDowns.selectedInvestigator;
      this.message.switchUserdropDownList = this.investigatorDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (userBeingSwitched == "QA") {
      this.message.switchedUser = this.qmsService.ccDropDowns.selectedQA;
      this.message.switchUserCurrentValue = this.qmsService.ccDropDowns.selectedQA;
      this.message.switchUserdropDownList = this.qaDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    }
    this.switchUserComponent.openswitchuser(userBeingSwitched, "CC");
  }

  onChildValueEmitted() {
    if (this.message.switchuserRole == "Evaluator") {
      this.qmsService.ccDropDowns.selectedEvaluator = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Investigator") {
      this.qmsService.ccDropDowns.selectedInvestigator = this.message.switchedUser;
    } else if (this.message.switchuserRole == "QA") {
      this.qmsService.ccDropDowns.selectedQA = this.message.switchedUser;
    }
    this.skipValidationsWhileSwitchingUser = true;
    this.switchUserComponent.saveMethod();
    this.update();
    this.switchUserComponent.visibleswitchUserPopup.close();
    this.switchUserComponent.visibleConfirmationPopup.close();
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  addWorkflow: boolean = false;
  parallelWorkflowList: any = [];
  async openAddWorkflow() {
    if (this.qmsService.activity.status == "In Progress" && await this.qmsService.validateExtension({ refNo: this.qmsService.activityId, extensionFor: "Activity" })) {

      setTimeout(() => {
        this.showSnackBar(this.qmsService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
    } else this.addWorkflow = true;
    this.isProcessing = false;
  };

  onWorkflowChildValueEmitted() {
    this.parallelWorkflowList = null;
    this.appService.getWorkflowByRefNo(this.qmsService.activityId).subscribe((data: any) => {
      this.parallelWorkflowList = data;
    });
    this.addWorkflow = false;
  }

  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag() {
    const data = { pageName: 'Detail', labelName: "Tag", tagRef: this.ccData.ccId };
    this.homepagetagComponent.openpopup(data);
  }

  onTagChildValueEmitted() {
  };

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  pdfDetailSearchText: string = '';
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {

              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }

            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  navigateToRisk() {
    this.goToTabByLabel("Risk Assessment");
  }

  @ViewChild('tabsGroup', { static: false }) tabsGroup: MatTabGroup;
  set tabGroup(tabGroup: MatTabGroup) {
    if (tabGroup)
      setTimeout(() => { this.selectedTabIndex = tabGroup._tabs["_results"].find((t: any) => t.textLabel == this.selectedTabIndex).position; }, 0);
  }

  goToTabByLabel(label: string) {
    if (this.tabsGroup) {
      const tabs = (this.tabsGroup?._tabs as any)._results,
        match = tabs?.find((x: any) => x.textLabel?.toUpperCase() === label.toUpperCase());

      if (match) {
        this.tabsGroup.selectedIndex = match.position;
      }
    }
  }

  reportFooterfieldValidation1: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterfieldValidation1 != undefined) {
        this.reportFooterfieldValidation1.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;
        this.selectBoxForFooter();
        this.reportFooterDropdown.length && (this.selectedReportFooter = this.reportFooterDropdown[0].displayExp);
      },
      error: (error: any) => {
        console.log('ngOnChangesReportFooter → getCodeListsByGroup', error)
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

}
